import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { CheckoutStatusType } from 'types/checkout'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { dateToString } from 'lib/helper'
import { fetchOrdersAction } from 'reducks/checkout/actions'
import { mergeCheckoutItems, mergeCheckoutWithItems } from 'reducks/checkout/operations'
import { StockUnionType } from 'types/stock'

const fetchBreadOrdersInPeriod = (
  startDate: Date,
  endDate: Date,
  storeRef: FirebaseDocRefType,
  breadRef: FirebaseDocRefType,
  status: CheckoutStatusType[],
  type: StockUnionType
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())

    const snapshots: FirebaseDocumentDataType = await storeRef
      .collection('store_checkouts')
      .where('type', '==', type)
      .where('status', 'in', status)
      .orderBy('date', 'asc')
      .startAt(dateToString(startDate))
      .endAt(dateToString(endDate))
      .get()

    const items = await mergeCheckoutItems(snapshots, [breadRef])
    const orders = mergeCheckoutWithItems(snapshots, items)

    dispatch(fetchOrdersAction(orders))
    dispatch(hideLoadingAction())
  }
}

export default fetchBreadOrdersInPeriod
